// Generated by scripts/generate-locale-availability.ts — do not edit directly.
// Source: content/{blog,case-studies,press-releases}/**, components/case-study-lpl/data.ts
// and the static route manifest (lib/seo/route-manifest.ts).

/** Family (first URL segment) → slug → locales it is available in. Only slugs missing from at least one locale are listed. */
export const CONTENT_LOCALE_AVAILABILITY: Readonly<
  Record<string, Readonly<Record<string, readonly string[]>>>
> = {
  "blog": {
    "alternative-business-loans": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "always-on-funding": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "build-business-credit-low-personal-score": [
      "en"
    ],
    "business-loan-calculator": [
      "en"
    ],
    "capital-or-equity-saas-founders": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "cult-brands-business-case": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "discount-disappears-shrink-order": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "figma-comparison-test": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "growth-lever-shipping-returns-policy": [
      "en"
    ],
    "highest-roas-channel-least-profitable": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "how-to-get-a-business-loan": [
      "en",
      "en-GB"
    ],
    "inventory-turnover-ratio": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "invoice-financing-vs-factoring": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "scaling-a-winning-campaign": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "the-accounting-data-advantage": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "what-is-working-capital": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ]
  },
  "our-customers": {
    "bionicgym": [
      "de",
      "en",
      "en-AU",
      "en-GB",
      "en-IE",
      "nl"
    ],
    "blvck": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "dynamic-funding": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "link-my-books": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "waka-coffee-tea": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ]
  },
  "press-releases": {},
  "grow-with-wayflyer": {
    "3bears": [
      "de",
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "correxiko": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "ghost-golf": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "kekoa-foods": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "little-words-project": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "petshop-co-uk": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "sand-cloud": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "spongelle": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ],
    "true-classic": [
      "en",
      "en-AU",
      "en-GB",
      "en-IE"
    ]
  }
};

/** Static route path (no leading slash) → locales it is available in. Only restricted routes are listed. */
export const STATIC_ROUTE_LOCALE_AVAILABILITY: Readonly<
  Record<string, readonly string[]>
> = {
  "black-friday": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "broker": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "compare-8fig": [
    "de",
    "en",
    "es",
    "nl"
  ],
  "compare-clearco": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "compare-comp-settle": [
    "de",
    "en",
    "es",
    "nl"
  ],
  "compare-iwoca": [
    "en-GB"
  ],
  "compare-payability": [
    "de",
    "en",
    "es",
    "nl"
  ],
  "flexible-funding": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "grow-with-wayflyer/location-expansions-upgrades": [
    "en",
    "en-AU",
    "en-GB"
  ],
  "partners/directory": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "payment-holiday": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "restaurant-business-loans": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "tools": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "tools/backwards-planner": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "tools/bf-report-card": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "tools/bundle-pricing": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "tools/clearance-ladder": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "tools/discount-break-even": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "tools/financing-break-even": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "tools/free-shipping-threshold": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "tools/offer-visualisation": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "tools/order-quantity-calculator": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "tools/readiness-scorecard": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ],
  "wayflyer-intelligence": [
    "en",
    "en-AU",
    "en-GB",
    "en-IE"
  ]
};
